import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Modal,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../../routes";

const IdSuccess = ({ id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5"><FormattedMessage id="lookupResults" /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{id}</strong>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button href={Routes.Home.path} variant="secondary">
          <FormattedMessage id="goHome" />
        </Button>
        <Button href={Routes.ForgotPassword.path} variant="secondary">
          <FormattedMessage id="findPassword" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default () => {
  const [email, setEmail] = useState("");
  const [id, setId] = useState("");
  const [msg, setMsg] = useState("");

  const onChange = (e) => {
    setEmail(e.target.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setMsg("이메일을 입력해주세요.");
      return;
    } else {
      setEmail("");
    }

    fetch(process.env.REACT_APP_API_URL + `/api/find/account?email=${email}`, {
      method: "get",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.username) {
          setId(resp.username);
          setMsg("");
        } else {
          setId("");
          setMsg("아이디가 존재하지 않습니다.");
        }
      });
  };
  return (
    <main>
      <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link
                as={Link}
                to={Routes.Signin.path}
                className="text-gray-700"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> <FormattedMessage id="goBack" />
              </Card.Link>
            </p>
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3><FormattedMessage id="findID" /></h3>
                <p className="mb-4"><FormattedMessage id="findEmail" /></p>
                <Form>
                  <div className="mb-4">
                    <Form.Label htmlFor="email"><FormattedMessage id="email" /></Form.Label>
                    <InputGroup id="email">
                      <Form.Control
                        required
                        autoFocus
                        type="email"
                        placeholder="john@company.com"
                        onChange={onChange}
                        value={email}
                      />
                    </InputGroup>
                  </div>
                  {msg && <p className="text-danger">{msg}</p>}
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={onSubmit}
                  >
                    <FormattedMessage id="findID" />
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {id && <IdSuccess id={id} />}
    </main>
  );
};
